import { ApiError } from '@ppay/client'

export class MerchantNotExistError extends ApiError {
  constructor(message = 'Merchant not exist') {
    super(message)
  }
}
